import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { useMemo } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * Header
 */

type Props = {
  codigo: string | null;
  descricao: string | null;
  status: number;
  onCodigoChange: (value?: string | null) => void;
  onDescricaoChange: (value?: string | null) => void;
  onStatusChange: (value?: number) => void;
  onClearFilters: () => void;
};

export const Header = ({
  codigo,
  descricao,
  status,
  onCodigoChange,
  onDescricaoChange,
  onStatusChange,
  onClearFilters,
}: Props) => {

  const campoOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Código',
      },
      {
        id: 2,
        label: 'Descrição',
      },
    ];
  }, [
  ]);

  const statusOptions = useMemo(() => {
    return [
      {
        id: 3,
        label: 'Todos',
      },
      {
        id: 1,
        label: 'Ativos',
      },
      {
        id: 2,
        label: 'Inativos',
      },
    ];
  }, [
  ]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-2">
          <div className="w-full grid md:grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="flex lg:col-span-2 md:col-span-2 gap-1">
              <div className="w-full grid grid-cols-3 gap-2">
                <div className="w-full col-span-1">
                  <DefaultSelectInput
                    name='campo'
                    label='Campo'
                    showSelectionLabel={false}
                    options={campoOptions}
                    value={codigo}
                    onChangeValue={e => onCodigoChange(e)}
                  />
                </div>

                <div className="w-full col-span-2">
                  <DefaultInput
                    name='descricao'
                    label='Descrição'
                    value={descricao}
                    onChangeValue={e => onDescricaoChange(e)}
                  />
                </div>
              </div>
            </div>

            <div>
              <DefaultSelectInput
                name='status'
                label='Status'
                showSelectionLabel={false}
                options={statusOptions}
                value={status}
                onChangeValue={e => onStatusChange(Number(e))}
              />
            </div>
          </div>

          <div className="w-full flex flex-col items-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}